// Funzione che crea il pdf con l'indirizzo di spedizione dell'utente
import {jsPDF} from "jspdf";
import 'jspdf-autotable'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";
import I18n from "i18n-js";
import { parseUserFullName } from "../utils";


const tab = "        "
const space = " "

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}




export const shipmentAddressPDF = (shipmentAddress) => {

  const line1 = parseUserFullName(shipmentAddress.first_name, shipmentAddress.last_name)
  const line2 = shipmentAddress.co ? I18n.t('js.newUserAddressForm.co') + ': ' + shipmentAddress.co : ''
  const line3 = shipmentAddress.street_square + ' ' + shipmentAddress.number + (shipmentAddress.indoor ? ', ' + shipmentAddress.indoor : '')
  const line4 = shipmentAddress.cap + ' ' + shipmentAddress.city
  const line5 = shipmentAddress.province.toUpperCase() + ' (' + shipmentAddress.country.toUpperCase() + ')'
  const line6 = shipmentAddress.phone_number ? I18n.t('js.newUserAddressForm.tel') + ': ' + shipmentAddress.phone_number : ''

  const maxLength = Math.max(line1.length, line2.length, line3.length, line4.length, line5.length, line6.length)

  const doc = new jsPDF('l', 'pt', 'a7');
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10)

  if (maxLength > 22 && maxLength < 29)
    doc.setFontSize(12)
  else if (maxLength >= 29 && maxLength <= 35)
    doc.setFontSize(10)
  else if (maxLength > 35)
    doc.setFontSize(8)

  const y = (doc.internal.pageSize.height - 65) / 2

  doc.text(line1, 15, y)
  doc.text(line2, 15, y + 20)
  doc.text(line3, 14, y + 40)
  doc.text(line4, 15, y + 60)
  doc.text(line5, 15, y + 80)
  doc.text(line6, 15, y + 100)

  var pdfName= 'Shipment_Address.pdf'
  doc.save(pdfName);
}
